import React, { useRef, useState } from "react";

const ImageComparisonSlider = ({ before, after }) => {
  const containerRef = useRef(null);
  const [position, setPosition] = useState(50); // percent

  const handleMove = (clientX) => {
    const bounds = containerRef.current.getBoundingClientRect();
    let newPosition = ((clientX - bounds.left) / bounds.width) * 100;

    if (newPosition < 0) newPosition = 0;
    if (newPosition > 100) newPosition = 100;

    setPosition(newPosition);
  };

  const handleTouch = (e) => {
    handleMove(e.touches[0].clientX);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full max-w-3xl mx-auto overflow-hidden rounded-xl shadow-lg cursor-col-resize select-none"
      onMouseMove={(e) => e.buttons === 1 && handleMove(e.clientX)}
      onTouchMove={handleTouch}
    >
      {/* After Image */}
      <img
        src={after}
        alt="After"
        className="w-full h-auto block"
      />

      {/* Before Image */}
      <img
        src={before}
        alt="Before"
        className="absolute top-0 left-0 h-full object-cover"
        style={{ width: `${position}%` }}
      />

      {/* Slider Bar */}
      <div
        className="absolute top-0 h-full w-1 bg-white shadow-md"
        style={{ left: `${position}%`, transform: "translateX(-50%)" }}
      />

      {/* Draggable Handle */}
      <div
        className="absolute top-1/2 left-1/2 w-8 h-8 bg-white rounded-full shadow-md border border-gray-300 flex items-center justify-center"
        style={{ left: `${position}%`, transform: "translate(-50%, -50%)" }}
      >
        <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
      </div>
    </div>
  );
};

export default ImageComparisonSlider;
